module.exports = __webpack_public_path__ + "media/src/admin/images/dark-logo-fbbd53d8016ed50e59eb697ea4e69512.png";